import React from 'react'
import Image from 'next/image'

import Passages from '@components/Passages'
import Choices from '@components/Choices'
import { PassageProps } from '@components/Passages'
import { ChoiceProps } from '@components/Choices/Choice'
import ExplanationButton from '@components/Button/ExplanationButton'

export type QuestionAndChoicesType = {
  viewResultMode: boolean
  isCorrect: boolean
  questionNumber: number
  questionTitle: string
  answerNumber: number
  passages: PassageProps[]
  choices: ChoiceProps[]
  isDelivery?: boolean
  explanationId?: number
}

export default function QuestionAndChoices({
  viewResultMode,
  isCorrect,
  questionNumber,
  questionTitle,
  answerNumber,
  passages,
  choices,
  isDelivery,
  explanationId,
}: QuestionAndChoicesType) {
  return (
    <div className={'flex max-[640px]:flex-col w-full sm:w-[720px] sm:mt-[32px] sm:mb-8 sm:px-4'}>
      {viewResultMode && (
        <Image
          className={'mr-8 w-12 h-12 mb-4 sm:mb-0'}
          src={isCorrect ? '/exam/correctCircle.png' : '/exam/wrongCross.png'}
          alt={isCorrect ? '정답입니다!' : '오답입니다'}
          width={48}
          height={48}
        />
      )}
      <div className={''}>
        {!viewResultMode && (
          <div className={'text-primary-text mb-[14px] sm:mb-6'}>
            가장 적합한 답 하나만 고르시오
          </div>
        )}
        <h1>{questionTitle}</h1>
        {viewResultMode && (
          <div className={'flex ml-7 mt-4 text-primary-text'}>
            정답 :{' '}
            <div className={'border ml-3 border-bosalpim text-lg my-auto w-[30px] rounded-full '}>
              <div className={'pl-[8.5px]'}>{answerNumber}</div>
            </div>
          </div>
        )}
        <Passages passages={passages} />
        <Choices questionNumber={questionNumber} choices={choices} isDelivery={isDelivery} />
        {viewResultMode && explanationId && <ExplanationButton explanationId={explanationId} />}
      </div>
    </div>
  )
}
